import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchCandidatePublicSubscription } from "./CandidatePublicSubcriptionAPI";

const initialState = {
    data: [],
    loading: false,
    error: null,
};

export const fetchCandidatePublicSubscriptionAsync = createAsyncThunk(
    "PublicSubscription/fetch",
    async (_, { rejectWithValue }) => {
        try {
            const data = await fetchCandidatePublicSubscription();
            const resp = data?.response

            if (!resp) {
                throw new Error("Invalid response structure");
            }
            return resp;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
)


const CandidatePublicSubscriptionSlice = createSlice({
    name: "CandidatePublicSubscription",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCandidatePublicSubscriptionAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCandidatePublicSubscriptionAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                state.error = null;
            })
            .addCase(fetchCandidatePublicSubscriptionAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            });
    }
})


export const selectCandidatePublicSubscription = (state) => state.candidatepublicsubscription.data;

export default CandidatePublicSubscriptionSlice.reducer;